var map = {
	"./communication/banners/banners_1.png": 4401,
	"./communication/banners/banners_2.png": 8141,
	"./communication/banners/banners_3.png": 5201,
	"./communication/new_year/new_year.png": 3200,
	"./communication/school/school_1.png": 8440,
	"./communication/school/school_2.png": 7475,
	"./communication/socials/socials_1.png": 3448,
	"./communication/socials/socials_2.png": 7576,
	"./communication/socials/socials_3.png": 8365,
	"./graphic/illustrations/illustrations_1.png": 4482,
	"./graphic/illustrations/illustrations_2.png": 5195,
	"./graphic/illustrations/illustrations_3.png": 1918,
	"./graphic/posters/posters_1.png": 6477,
	"./graphic/posters/posters_2.png": 7877,
	"./graphic/posters/posters_3.png": 4893,
	"./graphic/tiger/tiger_1.png": 7006,
	"./graphic/tiger/tiger_2.png": 5466,
	"./graphic/tiger/tiger_3.png": 3222,
	"./graphic/workers/1.png": 5692,
	"./graphic/workers/1_hover.png": 5144,
	"./graphic/workers/2.png": 5759,
	"./graphic/workers/2_hover.png": 8807,
	"./graphic/workers/3.png": 5686,
	"./graphic/workers/3_hover.png": 7717,
	"./graphic/workers/4.png": 2857,
	"./graphic/workers/4_hover.png": 7151,
	"./graphic/workers/workers_1.png": 1458,
	"./graphic/workers/workers_2.png": 5787,
	"./graphic/workers/workers_3.png": 5116,
	"./motion/telegram/telegram_1.png": 6091,
	"./presentation/corporate/corporate.png": 8668,
	"./presentation/museum/museum.png": 8748,
	"./presentation/upmoney/upmoney.png": 9505,
	"./product/onboarding/onboarding_1.png": 1711,
	"./product/onboarding/onboarding_2.png": 3554,
	"./product/onboarding/onboarding_3.png": 2542,
	"./product/redesign/redesign_1.png": 1599,
	"./product/redesign/redesign_2.png": 2219,
	"./product/redesign/redesign_3.png": 194,
	"./product/redesign/redesign_4.png": 7928,
	"./product/redesign/redesign_5.png": 5334,
	"./web/birthday/birthday_1.png": 4336,
	"./web/birthday/birthday_3.png": 1263,
	"./web/birthday/birthday_4.png": 8596,
	"./web/crm/crm_1.png": 9848,
	"./web/crm/crm_2.png": 2484,
	"./web/crm/crm_3.png": 4944,
	"./web/crm/crm_together.png": 16,
	"./web/salary/salary_1.png": 2250,
	"./web/salary/salary_3.png": 5189,
	"./web/salary/salary_4.png": 1903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4538;